import React from 'react';
import styled from 'styled-components';

import { BaseCross } from '../../svg';
import { NavigationButton } from '../NavigationButton';

interface IProps {
    backgroundGrey?: boolean;
    className?: string;
    helpText: string;
    onClick?(): void;
}

const BaseCloseButton: React.FC<IProps> = ({ className, ...props }) => (
    <NavigationButton className={className} {...props}>
        <BaseCross />
    </NavigationButton>
);

export const CloseButton = styled(BaseCloseButton)``;
